import script from "./TableList.vue?vue&type=script&setup=true&lang=js"
export * from "./TableList.vue?vue&type=script&setup=true&lang=js"

import "./TableList.vue?vue&type=style&index=0&id=5b073570&lang=css"

const __exports__ = script;

export default __exports__